module.exports = __webpack_public_path__ + "media/images/admin/icons/sliders-f7f169838f7f1e87e21d2ba4bddbfc3a.svg";